import { trackCommentary } from '../../../commentary/commentary.api';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';

export function trackLawyerCommentary({
  url,
  index,
  isAccessLimited,
}: {
  url: string;
  index: number;
  isAccessLimited: boolean;
}) {
  doctrineAnalytics('Lawyer LinkCommentaryClicked');
  trackCommentary(url, 'lawyer_commentaries', {
    position: index,
    isAccessLimited,
  });
}
